import {Component, Input} from '@angular/core';

@Component({
  selector: 'ep-loading-spinner',
  templateUrl: './loading-spinner.component.html'
})
export class LoadingSpinnerComponent {
  @Input() size = '74px'
  get style() {
    return {
      width: this.size,
      height: this.size
    }
  }
}
